import { render, staticRenderFns } from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=template&id=3a539c05&scoped=true&"
import script from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmCodificatorsBuilderNewOrEdit.vue?vue&type=style&index=0&id=3a539c05&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a539c05",
  null
  
)

export default component.exports